import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { getCookie } from '../helpers/utils';

const API_URL = '/api/duel_series';
const TABLE_API_URL = '/api/tables';


@Injectable({
  providedIn: 'root'
})
export class DuelSeriesService {

  constructor(
    private http: HttpClient,
  ) {

  }

  private getCsrfToken(): string {
    return getCookie('csrftoken');
  }

  get(id: number) {
    return this.http.get(`${API_URL}/${id}`);
  }

  finish(id: number) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'finish',
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  open(id: number) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'open',
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }


  incrementDuelSeriesScore(id: number, playerNum: number) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'increment',
      player: playerNum,
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  decrementDuelSeriesScore(id: number, playerNum: number) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'decrement',
      player: playerNum,
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  addDuel(id: number) {
    return this.http.post(`${API_URL}/${id}/add_duel`, {}, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  deleteDuel(ds_id: number, id: number) {
    return this.http.delete(`${API_URL}/${ds_id}/duel/${id}`, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  incrementDuelScore(id: number, duelId: number, playerNum: number) {
    return this.http.post(`${API_URL}/${id}/duel/${duelId}`, {
      action: 'increment',
      player: playerNum,
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  decrementDuelScore(id: number, duelId: number, playerNum: number) {
    return this.http.post(`${API_URL}/${id}/duel/${duelId}`, {
      action: 'decrement',
      player: playerNum,
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  createDuels(id: number, duels: any) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'create_duels',
      duels,
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  updateScore(id: number, playerOneScore: number, playerTwoScore: number) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'update_score',
      player_one_score: playerOneScore,
      player_two_score: playerTwoScore,
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  updateWinsCount(id: number, count: number) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'update_wins_count',
      wins_count: count,
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  updateYoutubeLink(id: number, link: string) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'update_youtube_link',
      youtube_link: link,
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  updateStatus(id: number, status: string) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'update_status',
      status
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  updateSchedule(id: number, schedule: Date) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'update_schedule',
      schedule,
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }

  getFreeTables(tournamentId: number) {
    return this.http.get(`/api/tournament/${tournamentId}/tables`);
  }

  getTable(tableId: number) {
    return this.http.get(`${TABLE_API_URL}/${tableId}`);
  }

  assignTable(id: number, table: string) {
    return this.http.post(`${API_URL}/${id}`, {
      action: 'assign_table',
      table
    }, {
      headers: {
        'X-CSRFToken': this.getCsrfToken()
      }
    });
  }
}
